import { Button } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePatch } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import ErrorAwareSelectField from '../../../common/inputfields/ErrorAwareSelectField';
import ErrorAwareTaxNumberField from '../../../common/inputfields/ErrorAwareTaxNumberField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';

class ModifyCustomer extends Component {
    //not complete
    componentDidMount() {
        console.log(this.props)
    }
    state = {
        selectedType: enums.getObjectByValue(enums.partnerForBillTypes, this.props.row.type),
        name: this.props.row.name,
        address: this.props.row.currentAddress,
        comment: this.props.row.comment,
        taxNumber: this.props.row.currentTaxNumber,
        errors: new Map(),
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/customer';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "name": this.state.name,
            "type": this.state.selectedType.value,
            "currentAddress": this.state.address,
            "comment": this.state.comment,
            "currentTaxNumber": this.state.taxNumber,
        };
        await handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Partner neve"
                            errors={this.state.errors}
                            value={this.state.name}
                            prevValue={this.props.row.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareSelectField
                            labelId="partner-type-label"
                            id="partner-type-label"
                            name="selectedType"
                            label="Partner típusa"
                            errors={this.state.errors}
                            value={this.state.selectedType}
                            prevValue={enums.getObjectByValue(enums.partnerForBillTypes, this.props.row.type)}
                            onChange={e => handleChangeEvent(e, this)}
                            options={enums.partnerForBillTypes}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTaxNumberField
                            name="taxNumber"
                            label="Jelenlegi adószám"
                            errors={this.state.errors}
                            value={this.state.taxNumber}
                            prevValue={this.props.row.currentTaxNumber}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="address"
                            label="Jelenlegi cím"
                            value={this.state.address}
                            prevValue={this.props.row.currentAddress}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            modify={true}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>

                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyCustomer);
